/**
 * 场次相关页面组件
 * 包括（场次创建，场次编辑，场次详情）
 * */
import React, { Component } from 'react';
import { connect } from '@souche-f2e/muji';
import { Form, Button, Modal, message, notification, Icon } from 'antd';
import { dispatch } from '@@/store';
import { AddCarTable, ChooseSeller, CreateForm, LookQrCode, UploadImg } from './_components';
import styles from './_style/index.less';
import luban from '@souche-f2e/luban-js';
const mapStateToProps = (rootState) => ({
    session: rootState.session,
    searchDealers: rootState.searchDealers,
});
class Session extends Component {
    constructor(props) {
        super(props);
        // desc 发拍
        this.sessionSend = () => {
            const { pageState } = this.props.session;
            // 鲁班埋点
            pageState === 0 && luban.send({
                eventType: 'click',
                typeId: 'PSGJB-CAR-QBSP-QBSPCG-CJCCFP',
            });
            this.props.form.validateFields()
                .then((formData) => {
                const sellerData = this.getSellers();
                if (!sellerData) {
                    notification.error({
                        message: '经销商数据必选',
                        description: '请选择经销商数据',
                    });
                    return false;
                }
                if (!this.props.session.roundPic) {
                    notification.error({
                        message: '场次图片不可为空！',
                        description: '请选择或上传图片',
                    });
                    return false;
                }
                formData.roundDeposit = formData.roundDeposit || 0;
                const checkedNum = this.props.session.carData.length;
                if (formData.roundAddressId) {
                    const address = formData.roundAddressId.split('--');
                    formData.roundAddressId = address[1];
                    formData.roundAddress = address[0];
                }
                if (formData.preStartDate) {
                    const date = formData.preStartDate.format('YYYY-MM-DD HH:mm:ss').split(' ');
                    formData.preStartDate = date[0];
                    formData.preStartTime = date[1];
                }
                if (formData.deadlineOfStartBidding) {
                    const date = formData.deadlineOfStartBidding.format('YYYY-MM-DD HH:mm:ss');
                    formData.deadlineOfStartBidding = date;
                }
                if (formData.endTime) {
                    const endTime = formData.endTime.format('YYYY-MM-DD HH:mm:ss');
                    formData.endTime = endTime;
                }
                if (formData[`carAuctionDuration${formData.auctionMode}`]) {
                    formData.carAuctionDuration = formData[`carAuctionDuration${formData.auctionMode}`];
                    delete formData[`carAuctionDuration${formData.auctionMode}`];
                }
                if (formData[`singleCarAuctionDuration${formData.auctionMode}`]) {
                    formData.singleCarAuctionDuration = formData[`singleCarAuctionDuration${formData.auctionMode}`];
                    delete formData[`singleCarAuctionDuration${formData.auctionMode}`];
                }
                checkedNum > 0 ? Modal.confirm({
                    title: '是否确认发拍',
                    onOk: () => {
                        dispatch.session.uploadAuction({
                            params: Object.assign(Object.assign({}, formData), { dealerList: JSON.stringify(sellerData) }),
                            isSave: false,
                            callback: () => {
                                setTimeout(() => {
                                    dispatch.router.back();
                                });
                            },
                        });
                    },
                }) : message.warning('请选择发拍车辆');
            })
                .catch(() => {
                this.props.form.validateFieldsAndScroll();
            });
        };
        // desc 保存-仅需场次名称
        /*sessionSaveOld = (showTip?: boolean) => {
          const { pageState } = this.props.session;
          // 鲁班埋点
          pageState === 0 && luban.send({
            eventType: 'click',
            typeId: 'PSGJB-CAR-QBSP-QBSPCG-CJCCBC',
          });
          const formData = this.props.form.getFieldsValue();
          if (formData.roundName && formData.roundName !== '') {
            const sellerData = this.getSellers();
            // if (formData.roundDepositNew) {
            //   formData.roundDeposit = formData.roundDepositNew;
            //   delete formData.roundDepositNew;
            // }
            if (formData.roundAddressId) {
              const address = formData.roundAddressId.split('--');
              formData.roundAddressId = address[1];
              formData.roundAddress = address[0];
            }
            if (formData.preStartDate) {
              const date = formData.preStartDate.format('YYYY-MM-DD HH:mm:ss').split(' ');
              formData.preStartDate = date[0];
              formData.preStartTime = date[1];
            }
            if (formData.deadlineOfStartBidding) {
              const date = formData.deadlineOfStartBidding.format('YYYY-MM-DD HH:mm:ss').split(' ');
              formData.deadlineOfStartBidding = date;
            }
            if (formData.endTime) {
              const endTime = formData.endTime.format('YYYY-MM-DD HH:mm:ss');
              formData.endTime = endTime;
            }
            showTip ? Modal.confirm({
              title: '是否确认保存',
              onOk: () => {
                this.save(formData, sellerData);
              },
            }) : this.save(formData, sellerData);
          }
          else {
            notification.warn({
              message: '保存场次信息，场次名称不可为空',
            });
          }
        };*/
        // desc 保存-全部必填
        this.sessionSave = (showTip) => {
            const { pageState } = this.props.session;
            pageState === 0 && luban.send({
                eventType: 'click',
                typeId: 'PSGJB-CAR-QBSP-QBSPCG-CJCCBC',
            });
            this.props.form.validateFields()
                .then((formData) => {
                const sellerData = this.getSellers();
                if (!sellerData) {
                    notification.error({
                        message: '经销商数据必选',
                        description: '请选择经销商数据',
                    });
                    return false;
                }
                if (!this.props.session.roundPic) {
                    notification.error({
                        message: '场次图片不可为空！',
                        description: '请选择或上传图片',
                    });
                    return false;
                }
                formData.roundDeposit = formData.roundDeposit || 0;
                const checkedNum = this.props.session.carData.length;
                if (formData.roundAddressId) {
                    const address = formData.roundAddressId.split('--');
                    formData.roundAddressId = address[1];
                    formData.roundAddress = address[0];
                }
                if (formData.preStartDate) {
                    const date = formData.preStartDate.format('YYYY-MM-DD HH:mm:ss').split(' ');
                    formData.preStartDate = date[0];
                    formData.preStartTime = date[1];
                }
                if (formData.deadlineOfStartBidding) {
                    const date = formData.deadlineOfStartBidding.format('YYYY-MM-DD HH:mm:ss');
                    formData.deadlineOfStartBidding = date;
                }
                if (formData[`carAuctionDuration${formData.auctionMode}`]) {
                    formData.carAuctionDuration = formData[`carAuctionDuration${formData.auctionMode}`];
                    delete formData[`carAuctionDuration${formData.auctionMode}`];
                }
                if (formData[`singleCarAuctionDuration${formData.auctionMode}`]) {
                    formData.singleCarAuctionDuration = formData[`singleCarAuctionDuration${formData.auctionMode}`];
                    delete formData[`singleCarAuctionDuration${formData.auctionMode}`];
                }
                if (formData.endTime) {
                    const endTime = formData.endTime.format('YYYY-MM-DD HH:mm:ss');
                    formData.endTime = endTime;
                }
                checkedNum > 0 ?
                    showTip ? Modal.confirm({
                        title: '是否确认保存',
                        onOk: () => {
                            this.save(formData, sellerData);
                        },
                    }) : this.save(formData, sellerData)
                    : message.warning('请选择发拍车辆');
            })
                .catch(() => {
                this.props.form.validateFieldsAndScroll();
            });
        };
        // desc 页面主体内容
        this.renderBody = () => {
            return (<div>
        <div className={styles.detail_body}>
          <CreateForm form={this.props.form}/>
          <UploadImg />
          <ChooseSeller form={this.props.form}/>
        </div>
      </div>);
        };
        this.state = {};
    }
    componentWillMount() {
        // desc 获取场次地址
        dispatch.session.getSessionPosition({});
        // desc 获取场次类型
        dispatch.session.getRoundType({});
        // desc 获取佣金规则列表
        dispatch.session.getBrokerageRuleList({});
        // desc 获取服务费规则列表
        dispatch.session.getCommissionRuleList({});
        // desc 获取场次详情
        dispatch.session.getSessionDetail({});
    }
    componentWillUnmount() {
        // desc 重置页面数据
        dispatch.session.RESET_STATE({});
    }
    // desc 获取经销商数据
    getSellers() {
        const sellerData = this.props.searchDealers.checkedOptions;
        const { roundType } = this.props.session;
        if (roundType === 1 && sellerData.length === 0) {
            message.warning('请选择小圈经销商');
            return false;
        }
        const newData = JSON.parse(JSON.stringify(sellerData).replace(/value/g, 'buyerCode').replace(/label/g, 'buyerName'));
        return roundType === 1 ? newData : [];
    }
    // desc 有未保存项时 【保存，发拍】提示
    noSaveTip(eventType) {
        Modal.confirm({
            icon: <Icon type="exclamation-circle"/>,
            title: '所作修改未保存，请先完成对应保存',
            onCancel: () => {
                switch (eventType) {
                    case 'save':
                        this.sessionSave(false);
                        break;
                    case 'send':
                        this.sessionSend();
                        break;
                }
            },
        });
    }
    // desc 保存信息
    save(formData, sellerData) {
        dispatch.session.uploadAuction({
            params: Object.assign(Object.assign({}, formData), { dealerList: JSON.stringify(sellerData) }),
            isSave: true,
            callback: () => {
                setTimeout(() => {
                    dispatch.router.back();
                });
            },
        });
    }
    // desc 页头
    renderHeader() {
        const { pageState } = this.props.session;
        return (<div className={styles.detail_header}>
        <div>
          <span className={styles.detail_header_title}>{this.props.title}</span>
          <span>
            {`场次编号${this.props.session.roundCode}`}
          </span>
        </div>
        {pageState === 2 && (<LookQrCode />)}
      </div>);
    }
    // desc 页尾
    renderFooter() {
        const { editIndex, editingKey } = this.props.session;
        return (<div className={styles.form_control}>
        <Button onClick={() => {
            (editIndex || editingKey.length > 0) ? this.noSaveTip('save') : this.sessionSave(true);
        }}>
          保存
        </Button>
        <Button type={'primary'} onClick={() => {
            (editIndex || editingKey.length > 0) ? this.noSaveTip('send') : this.sessionSend();
        }}>
          发拍
        </Button>
      </div>);
    }
    render() {
        const { roundStatus, pageState } = this.props.session;
        return (<div style={{
            padding: 4,
        }}>
        {this.renderHeader()}
        {this.renderBody()}
        <AddCarTable Form={this.props.form}/>
        {pageState !== 2 && (roundStatus === 0) && this.renderFooter()}
      </div>);
    }
}
// @ts-ignore
const FormSession = Form.create()(Session);
// @ts-ignore
export default connect(mapStateToProps)(FormSession);
